import {Component} from '@angular/core';
import {Filtro} from './filtros/filtro';
import {ActivatedRoute} from '@angular/router';
import {Page} from 'src/app/page';
import {Produto} from 'src/app/home/home/conteudo/produtos/produto';
import {ProdutosService} from 'src/app/home/home/conteudo/produtos/produtos.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'store-pesquisa',
    templateUrl: './pesquisa.component.html',
    styleUrls: ['./pesquisa.component.scss']
})
export class PesquisaComponent {

    public filtro: Filtro;
    public filtros: Map<string, any>;
    public tagsPesquisa: Array<string>;
    public produtosPage: Observable<Page<Produto>>;

    constructor(activatedRoute: ActivatedRoute, private produtoService: ProdutosService) {
        this.tagsPesquisa = [];
        this.filtros = new Map<string, any>();

        let termo: string;
        this.filtro = activatedRoute.snapshot.data.res[0];

        if (activatedRoute.snapshot.queryParams) {
            if (activatedRoute.snapshot.queryParams.term) {
                termo = activatedRoute.snapshot.queryParams.term;
                this.tagsPesquisa = termo ? [termo] : [];
            }

            if (activatedRoute.snapshot.queryParams.valor) {
                const valor = activatedRoute.snapshot.queryParams.valor === 'true'
                    ? true
                    : activatedRoute.snapshot.queryParams.coluna === 'areasNegocio'
                        ? Number(activatedRoute.snapshot.queryParams.valor)
                        : activatedRoute.snapshot.queryParams.valor;

                this.filtros.set(activatedRoute.snapshot.queryParams.coluna, [valor]);
                this.selecionarFiltro(activatedRoute.snapshot.queryParams);
            }
        }

        this.produtosPage = produtoService.getProdutos(this.filtros, this.tagsPesquisa, 0, 20);
    }

    recebeTag(tag) {
        this.tagsPesquisa.push(tag);
        this.produtosPage = this.produtoService.getProdutos(this.filtros, this.tagsPesquisa, 0, 20);
    }

    private selecionarFiltro(queryParams: any) {
        switch (queryParams.identificador) {
            case 'EXPLORAR': {
                this.filtro.explorar.forEach(explorar => {
                    if (explorar.coluna === queryParams.coluna) {
                        explorar.marcado = true;
                    }
                });
                break;
            }
            case 'AREAS': {
                this.filtro.areas.forEach(areas => {
                    if (areas.identificador === Number(queryParams.valor)) {
                        areas.marcado = true;
                    }
                });
                break;
            }
            case 'TIPO': {
                this.filtro.plataformas.forEach(plataformas => {
                    if (plataformas.chave === queryParams.valor.toUpperCase()) {
                        plataformas.marcado = true;
                    }
                });
                break;
            }
            case 'DESENVOLVEDOR': {
                this.filtro.desenvolvedores.forEach(desenvolvedor => {
                    if (desenvolvedor.chave === queryParams.valor.toUpperCase()) {
                        desenvolvedor.marcado = true;
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
    }

}

